import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import WebPages from "./WebPages";
import About from "./WebPages/About";
import { PrivateRoute } from "../components/PrivateRoute";
import Faq from "./WebPages/Faq";
import Support from "./WebPages/support";
import Login from "./Auth/Login";
import Register from "./Auth/Register";
import Dashboard from "./Dashboard";
import Admin from "./Admin";
import Home from "./Admin/Home";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/action";
import jwt_decode from "jwt-decode";
import ForgotPassword from "./Auth/ForgotPassword";
import ResetPassword from "./Auth/ResetPassword";

const Pages = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  // const handleScroll = () => {
  //   const position = window.pageYOffset;
  //   setScrollPosition(position);
  //   console.log(position);
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  const dispatch = useDispatch();
  const { token } = useSelector((state) => {
    const { token } = state.userData;
    return { token };
  });
  useEffect(() => {
    if (token) {
      const exp = jwt_decode(token).exp;
      const tokenIsValid = !(Date.now() >= exp * 1000);
      if (!tokenIsValid) {
        dispatch(logout());
      }
    }
  }, []);

  return (
    <Switch>
      <Route exact path="/" component={WebPages} />
      <Route path="/about" component={About} />
      <Route path="/faq" component={Faq} />
      <Route path="/support" component={Support} />
      <Route path="/login" component={Login} />
      <Route path="/register" component={Register} />
      <Route path="/forgotpassword" component={ForgotPassword} />
      <Route path="/resetpassword/:token" component={ResetPassword} />
      <PrivateRoute path="/dashboard" component={Dashboard} />
      <Route path="/admin" component={Admin} />
    </Switch>
  );
};

export default Pages;
